module.exports = __webpack_public_path__ + "img/vote_on_ban.92be0b14.svg";